/**
 * Beauty Solutions Cross-Store Redirect — Configuration
 * 🔴 IMPORTANT: Update storeURL below with your Beauty Solutions domain!
 */
window.BeautySolutionsConfig = {
  // 🔴 CHANGE THIS to your Beauty Solutions store URL (NO trailing slash)
  storeURL: 'https://beautysolutionsdistributor.com',

  // If you have a custom domain, use it instead:
  // storeURL: 'https://beautysolutions.com',

  // Enable/disable the redirect globally
  enabled: true,

  // UTM parameters for analytics tracking
  utmParams: {
    source: 'zulat',
    medium: 'referral',
    campaign: 'cross_store'
  },

  // Button text
  buttonText: 'Shop Now on Beauty Solutions',
  loadingText: 'Redirecting...',

  // Cart redirect (null = goes to storeURL homepage)
  cartRedirectURL: null
};
